import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allSysFeedback, replyFeedback,delSysFeedback} from '../../api'
  import { getToken } from '@/utils/auth'
  import {getUrl} from '../../api/comfig'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const  httpUrl=getUrl();

 
 

  
const headers= reactive({
  'token': getToken()
})
  
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
    { title: "图片", key: "pictures", align: "center" , customSlot: "thumbnail"},
    { title: "标题", key: "title", align: "center" },
    { title: "内容", key: "content", align: "center" },
    { title: "类型", key: "type", align: "center", customSlot: "type" },
    { title: "状态", key: "state", align: "center", customSlot: "state" },  
    { title: "账号", key: "userId", align: "center" }, 
    { title: "回复信息", key: "reply", align: "center" }, 
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllSysFeedback = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit};
    allSysFeedback(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllSysFeedback();
  
  
  const change = (page: any) => {
    getAllSysFeedback();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片

const signleImg = (imgur: any) => {
  layer.photos({
    imgList: [{ src: imgur }]
  })
}
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllSysFeedback();
  }
   
 

  const advertise = reactive({
    id:0,
    key: "", 
  })
  
  
  const deleFeedback = (row: any) => {
       var data={'id':row.id} 
       delSysFeedback(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllSysFeedback(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  const updateFeedback= (row: any) => {

    advertise.id = row.id; 
    advertise.reply = row.reply; 
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
 
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        replyFeedback(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllSysFeedback();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])
  
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  type: _withCtx(({ row }) => [
                    (row.type==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "意见"))
                      : (row.type==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "充值"))
                        : _createCommentVNode("", true)
                  ]),
                  state: _withCtx(({ row }) => [
                    (row.state==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "等待处理"))
                      : (row.state==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已处理"))
                        : _createCommentVNode("", true)
                  ]),
                  thumbnail: _withCtx(({ row }) => [
                    (row.pictures)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: row.pictures,
                          onClick: ($event: any) => (signleImg(row.pictures)),
                          style: {"width":"62.9px","height":"80px"}
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateFeedback(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("回复")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deleFeedback(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '300px'],
      btn: action11.value,
      title: "反馈"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_lay_form, {
            model: advertise,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "",
                prop: "key"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入描述",
                    modelValue: advertise.key,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((advertise.key) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})